import { Helmet } from "react-helmet";

function SocialMediaMetadata({ title, description, type = "website", image, url }) {

    const imageSource = typeof image === "string"
        ? image
        : (!!image && typeof image === "object")
            ? ((!!image.formats && image.formats["large"]) || image).url
            : null;

    return (
        <Helmet>
            {!!title &&
                <meta property="og:title" content={title} />
            }

            {!!description &&
                <meta property="og:description" content={description} />
            }

            {!!imageSource &&
                <meta property="og:image" content={imageSource} />
            }

            <meta property="og:url" content={url || (process.env.REACT_APP_URL || window.location.origin) + window.location.pathname} />
            <meta property="og:type" content={type} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@BCcampus" />
        </Helmet>
    )
};

export default SocialMediaMetadata;
